import { useCallback } from 'react';
import { isValidDate, isDateBeforeToday } from '../utils/dateUtils';

export const useFormValidation = (formData, setMessageBoxConfig, setShowMessageBox) => {
  const validateDates = useCallback(() => {
    let valid = false;
    if (formData.pickup_date && formData.delivery_date) {
      if (isValidDate(formData.pickup_date) && isValidDate(formData.delivery_date)) {
        if (formData.pickup_date <= formData.delivery_date) {
          valid = true;
        }
      }
    }
    return valid;
  }, [formData.pickup_date, formData.delivery_date]);

  const checkPastDates = useCallback(() => {
    const warnings = [];
    if (formData.pickup_date && isDateBeforeToday(formData.pickup_date)) {
      warnings.push("La date d'enlèvement est antérieure à aujourd'hui.");
    }
    if (formData.delivery_date && isDateBeforeToday(formData.delivery_date)) {
      warnings.push("La date de livraison est antérieure à aujourd'hui.");
    }
    return warnings;
  }, [formData.pickup_date, formData.delivery_date]);

  const validateFields = useCallback(
    fields => {
      let isValid = true;
      let newInvalidFields = [];

      if (fields.includes('client')) {
        if (!formData.client) {
          isValid = false;
          newInvalidFields.push('Code client: un client doit être choisi.');
        }
      }

      if (fields.includes('carrier')) {
        if (!formData.carrier) {
          isValid = false;
          newInvalidFields.push('Code transporteur: un transporteur doit être choisi.');
        }
      }

      if (fields.includes('dates')) {
        const datesValid = validateDates();
        if (!datesValid) {
          isValid = false;
          newInvalidFields.push(
            "Dates: les dates d'enlèvement et de livraison sont vides, invalides, ou la livraison est antérieure à l'enlèvement."
          );
        }
      }

      if (fields.includes('addresses')) {
        if (!formData.pickup_postcode || !formData.pickup_city) {
          isValid = false;
          newInvalidFields.push('Enlèvement: le code postal et la ville doivent être renseignés.');
        }
        if (!formData.delivery_postcode || !formData.delivery_city) {
          isValid = false;
          newInvalidFields.push('Livraison: le code postal et la ville doivent être renseignés.');
        }
      }

      if (newInvalidFields.length > 0) {
        setMessageBoxConfig({
          message: `Une ou plusieurs erreurs ont été détectées: ${newInvalidFields.join('\n')}`,
          type: 'ok',
          loading_button: false,
          input: false,
          onConfirm: () => setShowMessageBox(false),
          onCancel: () => setShowMessageBox(false),
        });
        setShowMessageBox(true);
      }

      return isValid;
    },
    [
      formData.client,
      formData.carrier,
      formData.pickup_postcode,
      formData.pickup_city,
      formData.delivery_postcode,
      formData.delivery_city,
      validateDates,
      setMessageBoxConfig,
      setShowMessageBox,
    ]
  );

  return {
    validateDates,
    validateFields,
    checkPastDates,
  };
};
